import {
  TOUR_DESTINATION_IN_DEMAND_START,
  TOUR_DESTINATION_IN_DEMAND_SUCCESS,
  TOUR_DESTINATION_IN_DEMAND_ERROR,
  TOP_TOUR_PARNERS_START,
  TOP_TOUR_PARNERS_SUCCESS,
  TOP_TOUR_PARNERS_ERROR,
  TOUR_RECOMMANDED_BIKES_START,
  TOUR_RECOMMANDED_BIKES_SUCCESS,
  TOUR_RECOMMANDED_BIKES_ERROR,
} from "../Constant/TourLandingConstant";

const initialState = {
  loading: false,
  destinationInDemandData: [],
  topTourPartners: [],
  recommandedBikes: [],
};

export default function TourLandingReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case TOUR_DESTINATION_IN_DEMAND_START:
      return {
        ...state,
        destinationInDemandData: [],
        loading: true,
      };
    case TOP_TOUR_PARNERS_START:
      return {
        ...state,
        topTourPartners: [],
        loading: true,
      };
    case TOUR_RECOMMANDED_BIKES_START:
      return {
        ...state,
        recommandedBikes: [],
        loading: true,
      };
    case TOUR_DESTINATION_IN_DEMAND_SUCCESS:
      return {
        ...state,
        destinationInDemandData: action.payload,
        loading: false,
      };
    case TOP_TOUR_PARNERS_SUCCESS:
      return {
        ...state,
        topTourPartners: action.payload,
        loading: false,
      };
    case TOUR_RECOMMANDED_BIKES_SUCCESS:
      return {
        ...state,
        recommandedBikes: action.payload,
        loading: false,
      };
    case TOUR_DESTINATION_IN_DEMAND_ERROR:
    case TOP_TOUR_PARNERS_ERROR:
    case TOUR_RECOMMANDED_BIKES_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
